"use client";

import { useViewedScreen } from "@packages/analytics";
import { useRestrictedContentCheck } from "@packages/kids";
import type { Pages } from "@packages/sdk";
import { snakeCase, useRequestPages, useSession } from "@packages/sdk";
import { Section, Sections } from "@ui/sections";

import { LoadingPage } from "../../../../components";

type PageClientProps = {
  initialData: Pages;
  page: string;
};

export const PageClient = ({ initialData, page }: PageClientProps) => {
  const { status } = useSession();
  const { query: queryPage } = useRequestPages({
    initialData,
    page,
    retryOnMount: false,
    retry: 0,
  });
  const isRestricted = useRestrictedContentCheck({ query: queryPage });

  if (queryPage.isLoading || isRestricted) return <LoadingPage />;

  useViewedScreen({
    screen: "page_detail",
    properties: {
      page_id: queryPage.data?.id,
      page_title: snakeCase(queryPage.data?.name),
      page_slug: page,
    },
    isReady:
      status === "unauthenticated" ||
      (status === "authenticated" && !!queryPage.data?.name),
  });

  return (
    <Sections title={queryPage.data?.name}>
      {queryPage.data?.sections.map((section) => (
        <Section
          key={section.id}
          section={section}
          page={{
            id: queryPage.data?.id,
            slug: page,
            title: queryPage.data?.name,
          }}
          screenName="page_detail"
        />
      ))}
    </Sections>
  );
};
